import MediaQuery from 'lib/media-query'
import lax from 'lib/wrapped-lax'
import { useIntersection } from 'stimulus-use'
import ApplicationController from 'controllers/application-controller'

export default class ParallaxStepsController extends ApplicationController {
  static targets = ['step', 'picture', 'image']

  connect () {
    super.connect()
    useIntersection(this)
    this.animationsInitialized = false

    MediaQuery.addListener('change', () => {
      console.log(MediaQuery.current)
      this.destroyAnimationsMaybe()
      this.initializeAnimationsMaybe()
    })
  }

  appear () {
    this.appeared = true
    this.initializeAnimationsMaybe()
  }

  destroyAnimationsMaybe () {
    if (!this.animationsInitialized) return
    this.animationsInitialized = false
    console.log('destroy')
    this.pictures.concat(this.images).forEach(el => {
      lax.removeElement(el)
    })
    lax.stop()
    // DIRTY FIX:
    lax.elements = []
    this.restoreStyles()
  }

  initializeAnimationsMaybe () {
    if (this.appeared && !this.animationsInitialized && MediaQuery.current.fits('medium')) {
      console.log('init')
      this.animationsInitialized = true
      this.initLax()
      this.steps.forEach((element, index) => { element.style.height = `${this.images[index].height}px` })
      this.pictures.forEach(this.initLaxForPicture.bind(this))
      this.images.forEach(this.initLaxForImage.bind(this))
    }
  }

  initLax () {
    lax.start()
    lax.addDriver('scrollY', function () {
      return window.scrollY
    }, { inertiaEnabled: true, frameStep: 1 })
  }

  initLaxForPicture (element, index) {
    const imageElement = this.images[index]

    lax.addElement(element, {
      scrollY: {
        height: [
          ['elCenterY-elHeight', 'elCenterY'],
          [index === 0 ? imageElement.height : 0, imageElement.height], // index 0 just for inertia of first pic
          {
            inertia: 5,
            inertiaMode: 'absolute',
            cssFn: (v) => `${v}px`
          }
        ]
      }
    })
  }

  initLaxForImage (element, index) {
    const nextElement = this.images[index + 1]

    lax.addElement(element, {
      scrollY: {
        translateY: [
          ['elCenterY', 'elCenterY+elHeight'], [0, nextElement?.height || 0],
          {
            inertia: 5,
            inertiaMode: 'absolute'
          }
        ]
      }
    })
  }

  restoreStyles () {
    this.steps.concat(this.pictures).forEach(element => { element.style.height = 'auto' })
    this.images.forEach(image => { image.style.transform = 'none' })
  }

  get steps () {
    return this.stepTargets
  }

  get pictures () {
    return this.pictureTargets
  }

  get images () {
    return this.imageTargets
  }
}
